export const QS_PARAMS_SESSION_KEY = 'qs_params';
export const URL_PARAMS_SESSION_KEY = 'storage';
export const URL_PARAMS_LOCAL_STORAGE_KEY = 'localStorage';
